import classNames from 'classnames';
import { Featherico, IconUser, IconVideo } from 'featherico';
import * as React from 'react';
import { useRef, useState } from 'react';
import { DataCenter } from '../../../../../../../types/CompanyDtos';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import { EventTrackingProps } from '../../../../../services/Tracking';
import styles from '../styles.m.less';
import GetADemoModalTabs, { DemoTab } from './GetADemoModalTabs';

interface Props {
    isOpen: boolean;
    setisOpen: (state: boolean) => void;
    userServer: DataCenter;
}

export const GetADemoModal = ({ isOpen, setisOpen, userServer }: Props) => {
    const [tab, setTab] = useState<DemoTab>(null);

    const containerRef = useRef<HTMLDivElement>(null);

    const handleClose = () => {
        setTab(null);
        setisOpen(false);
    };

    return (
        <Modal isOpen={isOpen} onClose={handleClose} size="LG_WIDTH">
            <div ref={containerRef} className={classNames(styles.container, { [styles.expanded]: tab !== null })}>
                <div className={styles.tabsHeadContainer}>
                    {userServer === 'prod-eu' ? (
                        <SelectOptionButton
                            onClick={() => setTab('demo')}
                            title="Request a Demo"
                            description="Connect with our sales team to receive a personalized demo of the tool"
                            icon={IconUser}
                            color="COLOR1"
                            tab={tab}
                            eventTracking={{ category: 'navigation header', action: 'request demo tab' }}
                        />
                    ) : (
                        <SelectOptionButton
                            onClick={() => setTab('consultation')}
                            title="Book a Consultation"
                            description="Dive into a discussion to more deeply understand your business needs around performance management"
                            icon={IconUser}
                            color="COLOR1"
                            tab={tab}
                            eventTracking={{ category: 'navigation header', action: 'request consultation tab' }}
                        />
                    )}

                    <SelectOptionButton
                        onClick={() => setTab('tutorial')}
                        title="Tutorial"
                        description="Explore and master our features with our step-by-step tutorial."
                        icon={IconVideo}
                        color="COLOR2"
                        tab={tab}
                        eventTracking={{ category: 'navigation header', action: 'tutorial tab' }}
                    />
                </div>

                {tab && <GetADemoModalTabs tab={tab} close={handleClose} />}
            </div>
        </Modal>
    );
};

type SelectButtonProps = {
    title: string;
    description: string;
    icon: React.ComponentType<Featherico>;
    onClick: () => void;
    color: 'COLOR1' | 'COLOR2';
    tab: DemoTab;
    eventTracking: EventTrackingProps;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>;

const SelectOptionButton = ({
    title,
    description,
    icon: Icon,
    onClick,
    color,
    tab,
    eventTracking,
}: SelectButtonProps) => {
    return (
        <Button
            onClick={onClick}
            className={classNames(styles.selectButton, { [styles.contracted]: tab !== null })}
            eventTracking={eventTracking}
        >
            <Icon className={classNames(styles.icon, [color === 'COLOR1' ? styles.color1 : styles.color2])} />
            <div className={styles.title}>{title}</div>
            {tab === null && <div className={styles.description}>{description}</div>}
        </Button>
    );
};
